import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { stopShowing } from '@/app/common/reducers/helpersShowSlice';
import IconAlert from './IconAlert';
import type { ReactNode } from 'react';

type HelpersShowState = string[];

interface RouteConfig {
  to: string;
  helper?: ReactNode;
}

interface RouteHelperAlertsProps {
  route: RouteConfig;
  className?: string;
}

interface SingleAlertProps {
  helpersShowState: HelpersShowState;
  id: string;
  html?: ReactNode;
  route: RouteConfig;
  className?: string;
}

const SingleAlert = ({ helpersShowState, id, html, route, className }: SingleAlertProps) => {
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setShow(true);
  }, [route]);

  return (
    <>
      {!helpersShowState?.includes(id) && html && (
        <IconAlert
          show={show}
          onClose={() => {
            setShow(false);
            dispatch(stopShowing(id));
          }}
          variant="info"
          className={classNames(className ?? 'my-2')}
          dismissible
        >
          <p className="mb-0 text-justify pe-3">{html}</p>
        </IconAlert>
      )}
    </>
  );
};

const RouteHelperAlerts = ({ route, className }: RouteHelperAlertsProps) => {
  const helpersShowState = useSelector(
    (state: { helpersShow: HelpersShowState }) => state.helpersShow,
  );

  return (
    <SingleAlert
      helpersShowState={helpersShowState}
      id={route.to}
      html={route?.helper}
      route={route}
      className={className}
    />
  );
};

export default RouteHelperAlerts;
